module.exports = __webpack_public_path__ + "img/3.365b9f82.webp";